import React from 'react';
import './index.scss';

/**
 * Status representável pelo badge. Estruturalmente compatível com o
 * RodadaStatus do contrato get-data-daily (helper/flux/automatic), mas
 * declarado localmente para o Design System não depender de helpers de domínio.
 */
export type StatusBadgeStatus = 'pre-psat' | 'psat' | 'pos-psat';

export type StatusBadgeVariant = 'outline' | 'tint' | 'solid';

interface StatusBadgeConfig {
  label: string,
  variant: StatusBadgeVariant,
}

/**
 * Progressão intraday da rodada: Pré-PSAT → PSAT → Pós-PSAT.
 * Os três tratamentos usam um ÚNICO azul (contorno/tinta/sólido) — status
 * nunca usa cores categóricas (verde/vermelho/âmbar são proibidos aqui).
 */
const STATUS_BADGE_CONFIG: Record<StatusBadgeStatus, StatusBadgeConfig> = {
  'pre-psat': { label: 'Pré-PSAT', variant: 'outline' },
  psat: { label: 'PSAT', variant: 'tint' },
  'pos-psat': { label: 'Pós-PSAT', variant: 'solid' },
};

interface StatusBadgeProps {
  status: StatusBadgeStatus,
  className?: string,
}

export default function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  // status vem da rede em runtime — um valor fora do contrato não pode derrubar o render.
  const config = STATUS_BADGE_CONFIG[status];
  if (!config) return null;
  const { label, variant } = config;

  return (
    <span className={`ds-status-badge ds-status-badge--${variant} ${className}`.trim()}>
      {label}
    </span>
  );
}
